enum BreakdownElementKey {
  CO_TWO = 'co2',
  MILEAGE = 'mileage',
  REPAYMENT = 'repayment',
  VEHICLE_NAMEPRICE = 'vehicleNameAndPrice',
}

export default BreakdownElementKey
